<template>
  <div class="teacher-detail">
    <div class="info-box">
      <img :src="teacherData.avatar" />
      <div class="info-box-left">
        <p class="teacher-name">
          {{teacherData.real_name}}
          <span
            class="teacher-level"
            v-if="teacherData.level"
          >【{{teacherData.level}}】</span>
        </p>
        <p class="teacher-introduction">身份审核：{{approval_status_list[teacherData.approval_status]}}</p>
        <p class="teacher-introduction">辅导班级：{{teacherData.class_names}}</p>
        <p class="teacher-introduction">简介：{{teacherData.introduction}}</p>
      </div>
    </div>
    <Tabs class="tabs" value="classes">
      <TabPane label="班级" name="classes">
        <Form ref="optionForm" :model="searchCondition" :label-width="70" inline>
          <FormItem label="班级名称">
            <Input
              v-model="searchCondition.class_name"
              placeholder="请输入班级名称关键字"
              style="width:200px;"
              clearable
              @keydown.native.prevent.enter="onSearch"
            ></Input>
          </FormItem>
          <FormItem label="所属课程">
            <Select v-model="searchCondition.course_basis_id" clearable style="width:200px">
              <Option v-for="item in courses" :value="item.id" :key="item.id">{{ item.course }}</Option>
            </Select>
          </FormItem>
          <FormItem label="班级类型">
            <EnumSelect
              type="ClassType"
              v-model="searchCondition.class_type"
              selector="select"
              style="width:200px"
            ></EnumSelect>
          </FormItem>
          <div>
            <FormItem label="讲师名称">
              <Input
                v-model="searchCondition.teacher"
                placeholder="请输入讲师名称关键字"
                style="width:200px;"
                clearable
                @keydown.native.prevent.enter="onSearch"
              ></Input>
            </FormItem>
            <FormItem label="班级状态">
              <EnumSelect
                type="ClassState"
                v-model="searchCondition.is_full"
                selector="select"
                style="width:200px"
              ></EnumSelect>
            </FormItem>
            <FormItem label="创建时间">
              <DatePicker
                type="datetime"
                v-model="start_at"
                placeholder="开始时间"
                format="yyyy-MM-dd HH:mm"
                style="width: 200px"
              ></DatePicker>
              <span>-</span>
              <DatePicker
                type="datetime"
                v-model="end_at"
                placeholder="截止时间"
                format="yyyy-MM-dd HH:mm"
                style="width: 200px"
              ></DatePicker>
            </FormItem>
            <FormItem class="search-form-btns">
              <div class="btn-wrap form-item-search">
                <Button icon="ios-search" @click="onSearch">搜索</Button>
                <Button icon="md-undo" @click="onReset">重置</Button>
              </div>
            </FormItem>
          </div>
        </Form>
        <div class="content">
          <Grid
            ref="grid"
            :columns="tableColumns"
            :data-url="'/api/assistant/classes/'+$route.query.id"
            :search="searchCondition"
            :rowsFormatter="onrowsFormatter"
            selectType="none"
            keyField="id"
            method="get"
          >
            <template slot-scope="{row}" slot="action">
              <div>
                <Button
                  type="text"
                  size="small"
                  :to="{name:'AssistStudentList',query:{id:row.id,from:'assist'}}"
                >学员列表</Button>
                <Button
                  type="text"
                  size="small"
                  :to="{name:'AssistHomeworkList',query:{id:row.id,from:'assist'}}"
                >-作业列表</Button>
              </div>
            </template>
          </Grid>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import { ClassType, ClassState } from "../../utils/enums.js";

export default {
  name: "AssistTeacherDetail",
  data() {
    return {
      id: this.$route.query.id,
      approval_status_list: {
        1: "审核中",
        2: "审核通过",
        3: "审核失败"
      },
      teacherData: {},
      start_at: "",
      end_at: "",
      courses: [],
      searchCondition: {
        class_name: "",
        course_basis_id: "",
        class_type: "",
        teacher: "",
        is_full: "",
        start_at: "",
        end_at: "",
        init: function() {
          this.class_name = "";
          this.course_basis_id = "";
          this.class_type = "";
          this.teacher = "";
          this.is_full = "";
          this.start_at = "";
          this.end_at = "";
        }
      },
      tableColumns: [
        { title: "所属课程", key: "course", minWidth: 200 },
        {
          title: "班级类型",
          key: "class_type_name",
          align: "center",
          minWidth: 100
        },
        { title: "班级名称", key: "class_name", minWidth: 120 },
        {
          title: "讲师名称",
          key: "teacher",
          minWidth: 150
        },
        {
          title: "班级人数",
          key: "student_number",
          align: "center",
          minWidth: 100
        },
        {
          title: "班级状态",
          key: "is_full",
          align: "center",
          minWidth: 100
        },
        {
          title: "创建日期",
          key: "created_at",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "right"
        }
      ]
    };
  },
  async created() {
    this.teacherData = await this.$http.get("/api/assistant/" + this.id);
    let classNames = [];
    this.teacherData.class_grade.forEach(c => {
      classNames.push(c.class_name);
    });
    this.teacherData.class_names = classNames.join("、");
    this.courses = await this.$http.get("/api/assistant/courses/" + this.id);
  },
  methods: {
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToTime(parseInt(i.created_at));
        i.class_type_name = ClassType.getValue(i.class_type);
        i.is_full = ClassState.getValue(i.is_full);
      });
    },
    onSearch() {
      if (this.start_at) {
        this.searchCondition.start_at = this.start_at.format(
          "yyyy-MM-dd hh:mm"
        );
      } else {
        this.searchCondition.start_at = "";
      }
      if (this.end_at) {
        this.searchCondition.end_at = this.end_at.format("yyyy-MM-dd hh:mm");
      } else {
        this.searchCondition.end_at = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.start_at = "";
      this.end_at = "";
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    }
  }
};
</script>
<style lang="scss" scoped>
.teacher-detail {
  .info-box {
    border: 1px solid #eee;
    padding: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    img {
      width: 100px;
      height: 100px;
      margin: 10px 30px;
    }
    .info-box-left {
      .teacher-name {
        margin-top: 15px;
        font-size: 16px;
      }
      .teacher-level {
        font-size: 14px;
        color: red;
      }
      .teacher-introduction {
        margin-top: 10px;
        font-size: 13px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .tabs {
    margin-top: 15px;
    overflow: visible;
    .item-width {
      width: 200px;
    }
    .btn-group {
      float: left;
    }
    .page {
      float: right;
    }
  }
}
</style>